<script>
    /*
    	FiltersButton.svelte

        11/18 - This is now a state button with up/down chevrons
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    const SVG_OPEN_PATH = '/img/chevron_down_purple.png';
    const SVG_CLOSE_PATH = '/img/chevron_up_purple.png';

    export let onClick;
    export let isSelected;

    onMount(() => {
    })

</script>

<style>

    .filters-button button {
        padding: 8px 20px;
        font-size: 14px;
        color: var(--tcui-primary);
        background: none;
        border-radius: 16px;
        border: 1px solid #F8F3F8;
        border-radius: 35px;    
    }

    .filters-button.selected button {
        background-color: #DFCDD8;
    }

    /*
    .filters-button button:hover {
        background-color: var(--tcui-ruby-light);
    }
    */

    .filters-button .button-content {
        display: flex;
        align-items: center;
    }

    .filters-button .button-content img {
        /* width: 13px; */
        /* height: 13px; */
        margin-left: 8px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if isSelected}
    <div class="filters-button selected">
        <button on:click={onClick}>
            <div class="button-content">
                Filters
                <img src={SVG_CLOSE_PATH} alt={'Close'} draggable="false" >
            </div>
        </button>
    </div>
{:else}
    <div class="filters-button">
        <button on:click={onClick}>
            <div class="button-content">
                Filters
                <img src={SVG_OPEN_PATH} alt={'Open'} draggable="false" >
            </div>
        </button>
    </div>
{/if}

